import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const DeFlag = createIcon({
  displayName: 'DeFlag',
  viewBox: '0 0 640 480',
  path: [
    <svg key="flag-de">
      <path d="M0 320h640v160H0z" fill="#ffce00" />
      <path d="M0 0h640v160H0z" />
      <path d="M0 160h640v160H0z" fill="#d00" />
    </svg>,
  ],
})
